import { tokenAliasOrValue } from "./base";
import { DimensionUnit } from "./dimension";
import { z } from "zod";
export const FontSizeUnit = z.enum(["Pixels", "Rem", "Percent"]);
export const FontSizeValue = z.object({
    unit: DimensionUnit,
    measure: z.number(),
});
export const FontSizeTokenData = tokenAliasOrValue(FontSizeValue);
